import { useCustomQuery } from '../../graphql';
import { FIND_GROUP_ASSIGNMENTS } from '../queries';

export const useGroupRoutines = (groupId?: string) => {
  const { data, isLoading } = useCustomQuery({
    cacheKey: ['group-routines', groupId],
    query: FIND_GROUP_ASSIGNMENTS,
    variables: {
      groupId,
    },
    options: {
      enabled: !!groupId,
    },
  });

  const routinesCount =
    data?.group?.findGroupAssignments?.routines?.length ?? 0;

  return {
    routinesCount,
    isLoading,
  };
};
